import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

export const getUserRole = async () => {
  const user = auth.currentUser;
  if (!user) return null;

  const ref = doc(db, "users", user.uid);
  const snap = await getDoc(ref);
  if (snap.exists()) {
    return snap.data().role; // e.g., "admin"
  }
  return null;
};
